const routes = [
    {
            path: "/mentora/transfer/out-request",
        component: () => import("../pages/Form.vue"),
        meta: {
            isAuthenticated: true,
            permission: "transferoutrequest_studentform"
        },
    },
    {
        path: "/mentora/transfer/out-requests",
        component: () => import("../pages/admin/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: "transferoutrequest_index"
        }
    },
    {
        path: "/mentora/transfer/out-request/:id",
        component: () => import("../pages/admin/Show.vue"),
        meta: {
            isAuthenticated: true,
            permission: "transferoutrequest_show"
        },
        props: route => ({
            formId: Number(route.params.id)
        })
    },
];

export default routes;
